// Core components
import { AfterViewInit, Component, OnDestroy } from "@angular/core";

// Third party components
import { ActivatedRoute } from '@angular/router';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CondoStructuresService } from 'src/app/modules/properties/condo-structures.service';

// Custom components

@Component({
  selector: 'formly-select-water-meter-section',
  template: `
  <mat-select [formControl]="formControl" [formlyAttributes]="field">
  <mat-option *ngIf="!to.defaultOptions"> --- </mat-option>
  <div *ngIf="to.defaultOptions">
    <div *ngFor="let option of to.defaultOptions">
      <mat-option [value]="option.value"> {{ option.label }} </mat-option>
    </div>
  </div>
  <div *ngFor="let item of items">
    <mat-option *ngFor="let subItem of item.values" [value]="subItem._id">
      {{ subItem.nome }}
    </mat-option>
  </div>
</mat-select>
  `,
})

export class SelectWaterMeterTypeComponent extends FieldType implements OnDestroy, AfterViewInit {
  private subscriptions: Subscription[] = [];
  items: any[] = [];

  constructor(
    private condoStructuresService: CondoStructuresService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngAfterViewInit() {
    const condoStructureId = this.activatedRoute.snapshot.params.mappingFormActiveSection
      .split("/")[1];
    this.subscriptions.push(
      this.condoStructuresService
        .getCondoStructuresListForWaterMeter(condoStructureId)
        .subscribe(res => {
          if (res.status) {
            const items = Array.isArray(res.data.items)
              ? res.data.items
              : Array.isArray(res.data)
              ? res.data
              : [];

            if (Array.isArray(items)) {
              items.forEach((item: any) => {
                if (Array.isArray(item.values)) {
                  item.values.forEach((subItem: any) => {
                    subItem.nome = subItem.nome.charAt(0).toUpperCase() + subItem.nome.slice(1).toLowerCase();
                  });
                }
              });
            }

            this.items = items;
          }
        })
    );
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
